export default "__VITE_ASSET__DDBpiVUf__"